// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-bcb839d2]{width:32px;height:32px;border-radius:50%;text-align:center;border:1px solid #158ad2}.avatar .icon[data-v-bcb839d2]{line-height:30px;font-size:16px;color:#158ad2}a[data-v-bcb839d2]{text-decoration:none}.user-area[data-v-bcb839d2]{margin-bottom:25px;line-height:1}.user-area a[data-v-bcb839d2]{font-size:14px}.email-confirmation[data-v-bcb839d2]{margin-top:5px}.email-resend[data-v-bcb839d2]{margin-left:5px}", ""]);
// Exports
module.exports = exports;
